import { useEffect, useState, createContext } from "react";
import Helmet from "react-helmet";

import { useSelector, useDispatch } from "react-redux";
import { NotificationsFilters } from "../../components/notifications/NotificationsFilters";
import { NotificationsTable } from "../../components/notifications/NotificationsTable";
import {
  fetchDistributors,
  selectAllDistributors,
} from "../../common/features/distributors/distributorsSlice";
import {
  fetchPointsOfSale,
  selectAllPointsOfSale,
} from "../../common/features/pointsOfSale/pointsOfSaleSlice";
import { Role } from "../../common/roles/role";
import notificationsService from "../../services/notifications.service";
import { useSnackbar } from "notistack";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

// 1. Crear el contexto
export const TargetTabContext = createContext();

export default function Notifications() {
  const dispatch = useDispatch();

  const { role, email } = useSelector((state) => state.auth.user);

  const [targetTab, setTargetTab] = useState("distributor");

  // Load distributors Redux
  const distributors = useSelector(selectAllDistributors);
  const distributorStatus = useSelector((state) => state.distributors.status);

  useEffect(() => {
    if (distributorStatus === "idle") {
      dispatch(fetchDistributors(role));
    }
  }, [distributorStatus, dispatch, role]);

  //Load pointsOfSale Redux
  const pointsOfSale = useSelector(selectAllPointsOfSale);
  const pointsOfSaleStatus = useSelector((state) => state.pointsOfSale.status);

  useEffect(() => {
    if (role !== Role.Kiosko && pointsOfSaleStatus === "idle") {
      dispatch(fetchPointsOfSale(role));
    }
  }, [pointsOfSaleStatus, role, dispatch]);

  const [rowsState, setRowsState] = useState({
    loading: false,
    page: 0,
    pageSize: 10,
    total: 0,
    rows: [],
    start_date_from: "",
    start_date_to: "",
    target_pdv: "",
    target_distributor: "",
    reload: true,
  });

  useEffect(() => {
    (async () => {
      if (!rowsState.reload) return;
      setRowsState((prev) => ({ ...prev, loading: true }));

      const results = await notificationsService
        .getAll({
          per_page: rowsState.pageSize,
          page: rowsState.page + 1,
          start_date_from: rowsState.start_date_from,
          start_date_to: rowsState.start_date_to,
          target:  targetTab === "distributor" ? rowsState.target_distributor : rowsState.target_pdv,
          role,
          type: targetTab === "distributor" ? "distributor" : "pdv",
        })
        .catch((e) => console.log(e));

      setRowsState((prev) => ({
        ...prev,
        loading: false,
        reload: false,
        total: results?.total || [],
        rows: results?.notifications || [],
      }));
    })();
  }, [
    rowsState.page,
    rowsState.pageSize,
    rowsState.start_date_from,
    rowsState.start_date_to,
    rowsState.target_distributor,
    rowsState.target_pdv,
    rowsState.reload,
    role,
    targetTab,
  ]);

  const { enqueueSnackbar } = useSnackbar();

  const actionToCancel = async (cellValues) => {
    console.log("Canceling notification", cellValues.row.id);
    try {
      await notificationsService.update({
        canceled_notification: {
          id: cellValues.row.id,
          end_date: cellValues.row.start_date - 1000,
          update_user: email,
        },
      });
      enqueueSnackbar("Notificación cancelada correctamente", {
        variant: "success",
      });
    } catch (error) {
      console.error("Error al cancelar la notificación:", error);
    }
  };

  return (
    <TargetTabContext.Provider
      value={{ targetTab, distributors, pointsOfSale }}
    >
      <h3>Notificaciones</h3>
      <Helmet>
        <title>Notificaciones - Marina BCN</title>
      </Helmet>

      <Tabs
        value={targetTab}
        onChange={() =>{setRowsState((prev) => ({ ...prev, reload: true }));
          targetTab === "distributor"
            ? setTargetTab("point_of_sale")
            : setTargetTab("distributor")}
        }
        textColor="secondary"
        indicatorColor="secondary"
        sx={{ mb: 2 }}
      >
        <Tab value="distributor" label="Distribuidor" />
        <Tab value="point_of_sale" label="Punto de venta" />
      </Tabs>

      <NotificationsFilters
        rowsState={rowsState}
        setRowsState={setRowsState}
        role={role}
      />
      <NotificationsTable
        rowsState={rowsState}
        setRowsState={setRowsState}
        actionToCancel={actionToCancel}
      />
    </TargetTabContext.Provider>
  );
}
